// eslint-disable-next-line import/prefer-default-export
export const scaleOptions = [
    { label: 'Adjusted for Batter Zone', value: 'normalized' },
    { label: 'Actual Pitch Height', value: 'actual' },
]
